import Card from "components/card";
import BarChart from "components/charts/BarChart";
import { MdArrowDropDown, MdArrowDropUp, MdPeople } from "react-icons/md";
import { barChartOptionsDailyTraffic } from "utils/charts";

const DailyTraffic = ({ analyticsData = [] }) => {
  const transformData = (data) => {
    if (!Array.isArray(data)) {
      return {
        labels: [],
        series: [{ name: "Visitors", data: [] }],
        percentageChange: 0,
      };
    }

    const aggregatedData = {};
    const weeklyData = {};

    data.forEach((row) => {
      if (!row || !row.dimensionValues || !row.metricValues) {
        return;
      }

      const rawDate = row.dimensionValues[0]?.value;
      if (!rawDate) return;

      const formattedDate = `${rawDate.slice(0, 4)}-${rawDate.slice(
        4,
        6
      )}-${rawDate.slice(6, 8)}`;
      const visitorCount = parseInt(row.metricValues[0]?.value || "0", 10);

      if (aggregatedData[formattedDate]) {
        aggregatedData[formattedDate] += visitorCount;
      } else {
        aggregatedData[formattedDate] = visitorCount;
      }

      const dateObj = new Date(formattedDate);
      const weekNumber = `${dateObj.getFullYear()}-W${Math.ceil(
        dateObj.getDate() / 7
      )}`;

      if (weeklyData[weekNumber]) {
        weeklyData[weekNumber] += visitorCount;
      } else {
        weeklyData[weekNumber] = visitorCount;
      }
    });

    const sortedDates = Object.keys(aggregatedData).sort(
      (a, b) => new Date(a) - new Date(b)
    );
    const sortedVisitors = sortedDates.map((date) => aggregatedData[date]);

    const weeks = Object.keys(weeklyData).sort();
    const lastWeek = weeklyData[weeks[weeks.length - 1]] || 0;
    const previousWeek = weeklyData[weeks[weeks.length - 2]] || 0;

    let percentageChange = 0;
    if (previousWeek > 0) {
      percentageChange = ((lastWeek - previousWeek) / previousWeek) * 100;
    }

    return {
      labels: sortedDates,
      series: [{ name: "Visitors", data: sortedVisitors }],
      percentageChange,
    };
  };

  const barChartDataDailyTraffic = transformData(analyticsData || []);
  const percentageChange = barChartDataDailyTraffic.percentageChange.toFixed(2);
  const isPositive = percentageChange >= 0;

  const latestDate =
    barChartDataDailyTraffic.labels[barChartDataDailyTraffic.labels.length - 1];
  const latestVisitorCount =
    barChartDataDailyTraffic.series[0]?.data[
      barChartDataDailyTraffic.labels.indexOf(latestDate)
    ] || 0;

  return (
    <Card extra="!p-[20px]">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
            <MdPeople className="text-xl text-primary" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
              Daily Traffic
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Visitor statistics
            </p>
          </div>
        </div>
        <div
          className={`flex items-center rounded-full px-3 py-1.5 text-sm font-medium ${
            isPositive
              ? "bg-green-100 text-green-600 dark:bg-green-900 dark:text-green-400"
              : "bg-red-100 text-red-600 dark:bg-red-900 dark:text-red-400"
          }`}
        >
          {isPositive ? (
            <MdArrowDropUp className="h-5 w-5" />
          ) : (
            <MdArrowDropDown className="h-5 w-5" />
          )}
          <span>{percentageChange}%</span>
        </div>
      </div>

      <div className="mt-6">
        <div className="mb-4">
          <p className="text-3xl font-bold text-gray-900 dark:text-white">
            {latestVisitorCount}
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Visitors Today
          </p>
        </div>

        <div className="h-[250px] w-full">
          {barChartDataDailyTraffic.labels?.length > 0 ? (
            <BarChart
              chartData={barChartDataDailyTraffic}
              chartOptions={barChartOptionsDailyTraffic}
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center">
              <p className="text-center text-gray-500 dark:text-gray-400">
                No data available
              </p>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default DailyTraffic;
